import {
    Home, ShieldCheck, BarChart3, AlertTriangle, Terminal,
    FileSignature, Eye, ShieldAlert, ToggleRight, Zap, Gauge,
    Radio, Cpu, Globe, Lock, Accessibility, Package, KeyRound,
    Fingerprint, Hash, Shield as ShieldIcon, RotateCcw, GitBranch, FileText
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface NavItem {
    path: string
    label: string
    icon: LucideIcon
}

export interface NavGroup {
    label: string
    emoji: string
    items: NavItem[]
    defaultOpen?: boolean
}

export const NAV_GROUPS: NavGroup[] = [
    {
        label: 'Centro de Control',
        emoji: '🚀',
        defaultOpen: true,
        items: [
            { path: '/', label: 'Panel', icon: Home },
            { path: '/licenses', label: 'Licencias', icon: ShieldCheck },
            { path: '/versions', label: 'Versiones', icon: GitBranch },
        ]
    },
    {
        label: 'Monitoreo en Vivo',
        emoji: '📡',
        defaultOpen: true,
        items: [
            { path: '/telemetry', label: 'Telemetría', icon: BarChart3 },
            { path: '/errors', label: 'Errores', icon: AlertTriangle },
            { path: '/performance', label: 'Performance', icon: Gauge },
        ]
    },
    {
        label: 'Control Remoto',
        emoji: '⚙️',
        items: [
            { path: '/commands', label: 'Comandos', icon: Terminal },
            { path: '/feature-flags', label: 'Feature Flags', icon: ToggleRight },
            { path: '/circuit-breaker', label: 'Circuit Breaker', icon: Zap },
        ]
    },
    {
        label: 'Legal & Compliance',
        emoji: '📄',
        items: [
            { path: '/contracts', label: 'Contratos', icon: FileSignature },
            { path: '/security', label: 'Security Audit', icon: ShieldAlert },
            { path: '/transparency', label: 'Transparencia', icon: Eye },
            { path: '/accessibility', label: 'Accesibilidad', icon: Accessibility },
        ]
    },
    {
        label: 'Base de Conocimiento',
        emoji: '📚',
        items: [
            { path: '/docs', label: 'Documentación', icon: FileText },
            { path: '/encryption', label: 'Encriptación', icon: Lock },
            { path: '/csp', label: 'CSP Policy', icon: ShieldIcon },
            { path: '/watermark', label: 'Watermarking', icon: Fingerprint },
            { path: '/integrity', label: 'Integridad (SRI)', icon: Hash },
            { path: '/secrets', label: 'Secrets Scanner', icon: KeyRound },
            { path: '/wasm', label: 'WebAssembly', icon: Cpu },
            { path: '/service-worker', label: 'Service Worker', icon: Globe },
            { path: '/bundle', label: 'Bundle Analyzer', icon: Package },
            { path: '/snapshots', label: 'Snapshots', icon: RotateCcw },
            { path: '/websockets', label: 'WebSockets', icon: Radio },
        ]
    },
]

// Flat list para rutas (compatibilidad)
export const ALL_NAV_ITEMS: NavItem[] = NAV_GROUPS.flatMap(g => g.items)
